const projectTypes = {
  SET_SELECTED: 'projects/setSelected',
};

export default projectTypes;
